import { createFileRoute } from "@tanstack/react-router"

import { LinkExpired } from "#pages/login/link-expired.tsx"

export const Route = createFileRoute("/_auth/link-expired")({
  component: LinkExpired,
})
